import React from 'react';
import { useAuth } from '../../context/AuthContext';

const SedeSelector = () => {
  const { sedeActiva, sedes, cambiarSede, canSelectSede, colorSede } = useAuth();

  // Don't show selector if user can't select sede
  if (!canSelectSede || sedes.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-white border-b">
      <span className="text-sm font-medium text-gray-700">Sede:</span>
      <div className="flex gap-2">
        {sedes.map((sede) => {
          const isActive = sede.nombre === sedeActiva;
          return (
            <button
              key={sede.id}
              onClick={() => cambiarSede(sede.nombre)}
              className={`px-4 py-2 rounded-lg font-medium text-sm transition-all ${
                isActive
                  ? 'text-white shadow-md'
                  : 'text-gray-600 bg-gray-100 hover:bg-gray-200'
              }`}
              style={
                isActive
                  ? { backgroundColor: sede.color_principal }
                  : {}
              }
            >
              {sede.nombre}
            </button>
          );
        })}
      </div>
      {sedeActiva && (
        <div className="ml-auto flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: colorSede }}
          />
          <span className="text-xs text-gray-500">
            {sedeActiva}
          </span>
        </div>
      )}
    </div>
  );
};

export default SedeSelector;
